<template>
  <Popup
    :title="'已授权应用'"
    :visible="visible"
    :singleBtn="true"
    @popupCancle="checkApp"
    @popupOk="checkApp"
  >
    <a-table
      size="middle"
      bordered
      :columns="columns"
      :data-source="dataList"
      rowKey="id"
      :scroll="{ x: 1200 }"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
    </a-table>
  </Popup>
</template>

<script>
import Popup from '@/components/common/Popup';

const columns = [
  {
    align: 'center',
    title: '系统名',
    dataIndex: 'title',
    key: 'title',
    width: 200,
  },
  {
    align: 'center',
    title: '系统',
    dataIndex: 'channelColumnList',
    width: 200,
  },
  {
    align: 'center',
    title: '频率限制类型',
    dataIndex: 'author',
    width: 200,
  },
  {
    align: 'center',
    title: '频率',
    dataIndex: 'createTime',
    width: 200,
  },
  {
    align: 'center',
    title: '加密',
    dataIndex: 'isReview',
  },
];
export default {
  data() {
    return {
      visible: false,
      columns,
      dataList: [],
      loading: false,
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
    };
  },
  components: {
    Popup,
  },
  methods: {
    checkApp() {
      this.visible = !this.visible;
    },
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
    },
  },
};
</script>
